export const columns = [
  {
    title: 'Tip timer',
    field: 'timerTypeValue',
    align: 'left',
    type: 'string',
    disableSorting: true
  },
  {
    title: 'Valoare timer',
    field: 'timerValue',
    align: 'left',
    type: 'string',
    disableSorting: true
  },
  {
    title: 'Descrirere timer',
    field: 'timerDescription',
    align: 'left',
    type: 'string',
    width: '700px',
    disableSorting: true
  }
]
